var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mr-1",class:{'disabled': _vm.disabled},attrs:{"id":"toogle switch"}},[_c('label',{staticClass:"switch"},[_c('input',_vm._b({attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.checked},on:{"change":_vm.onChange}},'input',_vm.$attrs,false)),_c('span',{staticClass:"slider round"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }